import listActions from 'src/modules/benchmarkScore/list/benchmarkScoreListActions';
import BenchmarkScoreService from 'src/modules/benchmarkScore/benchmarkScoreService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'BENCHMARKSCORE_DESTROY';

const benchmarkScoreDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: benchmarkScoreDestroyActions.DESTROY_STARTED,
      });

      await BenchmarkScoreService.destroyAll([id]);

      dispatch({
        type: benchmarkScoreDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.benchmarkScore.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/benchmark-score');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: benchmarkScoreDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: benchmarkScoreDestroyActions.DESTROY_ALL_STARTED,
      });

      await BenchmarkScoreService.destroyAll(ids);

      dispatch({
        type: benchmarkScoreDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doChangeSelected([]));
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.benchmarkScore.destroyAll.success'),
      );

      getHistory().push('/benchmark-score');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: benchmarkScoreDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default benchmarkScoreDestroyActions;
